<div class="vlist-wrapper">
  <div class="d-grid grid-column align-items-center">
    <div class="form-group mb-0 d-flex align-items-center ml-auto">
      <div class="cursor" matTooltip="Back" *ngIf="service.getConfiguration('tenantGenericConfig')?.entityList?.entityListWidgets && 
        list?.pageType === 'vehicles' && (isWidgetShow || filterApplied || service.getEntitiesFilter()?.length)" (click)="handleBack()">
        <img alt="filter" src="../../../../assets/images/arrow_circle_left.svg" />
      </div>
      <div class="ml-2 filter-category-indication-text">{{ appliedFilterCategory?.['category']?.[0] ?? appliedFilter?.['filterFields']?.['category']?.[0] }}</div>
      <app-search (searchItem)="onSearchItem($event)" class="d-flex"
        *ngIf="!service.getConfiguration('tenantGenericConfig')?.entityList?.entityListWidgets"
        [pageType]="tenantCategory === 'monotainer' ? 'monotainer' : 'entities'"></app-search>
    </div>
    <div *ngIf="(siteId && tenantCategory === 'monotainer' && list?.data?.length) || isShow" class="multitag"
      [hidden]="!isActiveFilter">
      <mat-checkbox class="field checkbox-width" [disabled]="isTaggable && isUntag" [formControl]="tag"
        (change)="onTagOptionChanged(ENTITY_TAG_STATUS?.TAG, $event)">
        Tag
      </mat-checkbox>
      <mat-checkbox class="field checkbox-width" [disabled]="isTaggable && !isUntag" [formControl]="unTag"
        (change)="onTagOptionChanged(ENTITY_TAG_STATUS?.UNTAG, $event)">
        Untag
      </mat-checkbox>
      <div (click)="onTagOrUntagClick(isUntag)" *ngIf="uniqueIdList?.length">
        <img src="../../../../assets/images/dover-add-icon.svg" class="d-grid h-27 cursor hover-color" title="Tag/Untag"
          alt="Tag/Untag" />
      </div>
    </div>
    <div class="d-flex align-items-center jc-end gp10">
      <div *ngIf="service.rbacManagement('entities_DateTimeRangeFilter')" class="d-flex gap-2 align-items-center">
        <div class="widget-edit pdt-5 calender-pop-scroll report-date-field home-datetime-range">
          <form [formGroup]="datepickerForm">
          <app-datetime-range class="" formControlName="thisdate" [isDisabled]="false" [label]="'Date Range'" [autoApply]="false"
            [showCancel]="true" [timePicker]="true" [timePicker24Hour]="true" [timePickerSeconds]="true"
            [showCustomRangeLabel]="true" [alwaysShowCalendars]="true" [keepCalendarOpeningWithRange]="true" 
            [opens]="'left'" (datePassed)="saveTime($event)">
          </app-datetime-range>
          </form>
        </div>
      </div>
      <div id="filter" class="cursor" (click)="handleFilter(true)" [ngClass]="{ 'active-icon': _searchKey || hasEntityFilters ||  _filterApplied}"
        *ngIf="service.rbacManagement('entities_EntityFilter')">
        <div *ngIf="!_searchKey && !hasEntityFilters &&  !_filterApplied">
          <img alt="filter" src="../../../../assets/images/Filter-validops.svg" />
        </div>
        <div *ngIf="_searchKey || hasEntityFilters ||  _filterApplied">
          <img alt="filter" src="../../../../assets/images/filter_alt.svg" /> Filter ({{filterCount + (_searchKey ? 1 : 0) + (entitiyFilters?.isActiveAlerts ? 1 : 0) + (entitiyFilters?.isActiveDTCCases ? 1 : 0)}})
        </div>
      </div>
      <app-button *ngIf="entityOnboardButton?.label" [label]="entityOnboardButton?.label"
        [type]="entityOnboardButton?.type" [option]="entityOnboardButton?.option" [color]="entityOnboardButton?.color"
        [tooltip]="entityOnboardButton?.tooltip" [disabled]="entityOnboardButton?.disabled"
        [icon]="entityOnboardButton?.icon" [iconColor]="entityOnboardButton?.iconColor"
        [size]="entityOnboardButton?.size" (clicked)="onEntityOnboardButtonClick($event, entityOnboardButton)">
      </app-button>
      <app-toggle-view (changeView)="onChangeView($event)" *ngIf="service.rbacManagement('entities_EntityListToggle')">
      </app-toggle-view>
    </div>
  </div>
  <div class="make-responsive-entitylist-vehicle uni-entitylist vehicle-drilldown" *ngIf="service.getConfiguration('tenantGenericConfig')?.entityList?.entityListWidgets && 
      list?.pageType === 'vehicles' && (isWidgetShow || filterApplied)">
    <mat-card class="example-card cursor uni-mat-card" *ngFor="let widget of vehicleWidgets">
      <mat-card-content>
        <div class="box padt-10 padb-10">
          <div>
            <img [src]="widget?.icon" class="h-38" alt="car-img" />
          </div>
          <div class="align-items-center">
            <div class="widget-value" [title]="+widget?.value?.toFixed(3)">
              {{ widget?.value && widget?.trimmedValue ? widget?.trimmedValue : 0 }}
            </div>
            <div class="widget-title">
              {{ widget?.title }}
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
  <app-entity-categories
    *ngIf="service.getConfiguration('tenantGenericConfig')?.entityList?.entityListWidgets && list?.pageType === 'vehicles' && !isWidgetShow && !filterApplied"
    (collapse)="handleFilter($event)" (filterValue)="handleFilterSelection($event)" [pageType]="'entityList'">
  </app-entity-categories>
  <div class="form-gap position-relative d-flex flex-column uni-profile-card" [ngClass]="toggle ? 'make-responsive-entitylist' : ''"
    *ngIf="list?.data?.length; else noEntityData">
    <mat-card class="example-card cursor uni-mat-card" *ngFor="let item of list?.data; let i = index; trackBy: trackByEntityItem"
      [ngClass]="{ grey: !item?.status, '': !toggle }" (click)="onMatCardClick(item?._id)">
      <div class="card-content-wrapper" [ngClass]="{ blurred: selectedCardId === item?._id }"
        (click)="clearCardSelection($event, item?._id)">
        <mat-card-content>
          <app-tile-header [content]="item" [taggable]="isTaggable" [iconList]="entityIconGroup?.headerIconList"
            (tagChanged)="onTileHeaderTagChanged($event)" (cardSelected)="onCardClick($event)">
          </app-tile-header>
          <ng-container *ngIf="entityCardView === ENTITY_CARD_VIEW?.VALIDOPS_VEHICLE_TRACK; else assetTrack;">
            <app-tile-body-validops-vehicle [content]="item" [pageType]="list?.pageType">
            </app-tile-body-validops-vehicle>
          </ng-container>
          <ng-template #assetTrack>
            <ng-container *ngIf="entityCardView === ENTITY_CARD_VIEW?.ASSET_TRACK; else monotainerTrack;">
              <app-tile-body-asset-track [content]="item" [pageType]="list?.pageType"
                [iconList]="entityIconGroup?.bodyIconList">
              </app-tile-body-asset-track>
            </ng-container>
          </ng-template>
          <ng-template #monotainerTrack>
            <ng-container *ngIf="entityCardView === ENTITY_CARD_VIEW?.MONOTAINER_TRACK; else generic;">
              <app-monotainer-data [content]="item"></app-monotainer-data>
            </ng-container>
          </ng-template>
          <ng-template #generic>
            <app-tile-body [pageType]="list?.pageType" [content]="item"></app-tile-body>
          </ng-template>
          <app-tile-footer class="w-100" [content]="item" [iconList]="entityIconGroup?.footerIconList">
          </app-tile-footer>
          <div class="ml-auto"></div>
        </mat-card-content>
      </div>
      <div class="icon-overlay" *ngIf="selectedCardId === item?._id">
        <i class="icon-class-1">
          <img src="../../../../assets/images/edit-validops.svg" alt="Edit"
            (click)="onEntityOverlayAction($event, item, 'edit')" />
        </i>
        <!-- <i class="icon-class-2">
          <img src="../../../../assets/images/delete-validops.svg" alt="Delete"
            (click)="onEntityOverlayAction($event, item, 'delete')" />
        </i> -->
      </div>
    </mat-card>
  </div>
  <ng-template #noEntityData>
    <div class="no-records">
      <div class="d-flex justify-content-center align-items-center vh-75">
        <div class="text-center image-style">
          <img src="../../../assets/images/nodata.svg" class="w-10" alt="no-data" />
        </div>
      </div>
    </div>
  </ng-template>
</div>
<app-filter-panel [isCollapsed]="isOpenFilter" [appliedFilter]="appliedFilter" (collapse)="handleFilter($event)" [pageType]="'entity'" [searchInput]="_searchKey"
  (selectedFilters)="applyFilterSelection($event)" (searchItem)="onSearchItem($event)" (clearFilters)="clearAllFilters()" [filterValues]="filterFields" [includeAlerts]="isAlertIncluded" [includeDtc]="isDtcIncluded" [entityFilters]="entitiyFilters">
</app-filter-panel>